import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Intro from './components/Intro';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Lightbox from './components/Lightbox'; // Importa el componente de Lightbox
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronUp } from '@fortawesome/free-solid-svg-icons/faCircleChevronUp';

import './styles/layouts/App.css';
import './styles/components/Header.css';
import './styles/components/Navigation.css';
import './styles/components/Intro.css';
import './styles/components/Projects.css';
import './styles/components/Services.css';
import './styles/components/Contact.css';
import './styles/components/Footer.css';
import './styles/components/Lightbox.css';
import './styles/components/CustomAlert.css';

function App() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false); // Estado para el botón de volver al inicio

  // Función para cerrar el lightbox
  const closeLightbox = () => {
    setSelectedProject(null);
  };

  // Función para manejar el scroll
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowScrollTop(true); // Mostrar el botón cuando se ha hecho scroll hacia abajo
    } else {
      setShowScrollTop(false); // Ocultar el botón cuando no hay scroll suficiente
    }
  };

  // Añadir el event listener para el scroll
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); // Limpiar el event listener al desmontar
    };
  }, []);

  // Función para volver al inicio de la página
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      <div className="left-side-strip"></div>
      <Header />
      <Navigation />
      <main>
        <Intro />
        <Services />
        <Projects />
        <Contact />
      </main>
      <Footer />
      
      {/* Botón para volver al inicio */}
      {showScrollTop && (
        <button onClick={scrollToTop} className="scroll-top-btn show">
          <FontAwesomeIcon icon={faCircleChevronUp}/>
        </button>
      )}

      {/* Renderiza el Lightbox aquí en el nivel superior */}
      {selectedProject && <Lightbox project={selectedProject} closeLightbox={closeLightbox} />}
    </div>
  );
}

export default App;
